import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const usePlaybooks = () => {
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const { platformId } = useParams();  
    const [data, setData] = useState({ playbooks: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });

    const handleModalConfig = (row = {}) => {
        setModalConfig((prev) => ({ row, isOpen: !prev.isOpen }));
    };

    const getPlaybooks = async () => {
        const { data, pagination } = await axiosInstance.get(`/playbooks/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            playbooks: data,
            pagination
        });
    };

    const handleStatus = async (id, isActive) => {
        await axiosInstance.patch(`/playbooks/${platformId}/status/${id}`, {
            status: isActive ? "inactive" : "active"
        });
        getPlaybooks();
    };

    const handleRowActions = async (row, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/playbooks/${platformId}/${row._id}`);
            getPlaybooks();
            return;
        }
        handleModalConfig(row);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getPlaybooks();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions, handleStatus }),
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getPlaybooks
    };
};

export default usePlaybooks;
